import { UploadListItemProps } from '@progress/kendo-react-upload';

const fileTypeIcons: { [key: string]: string } = {
  exe: 'k-i-file-config',
  pdf: 'k-i-file-pdf',
  jpg: 'k-i-file-image',
  jpeg: 'k-i-file-image',
  png: 'k-i-file-image',
  gif: 'k-i-file-image',
  bmp: 'k-i-file-image',
  doc: 'k-i-file-word',
  docx: 'k-i-file-word',
  xls: 'k-i-file-data',
  xlsx: 'k-i-file-data',
  txt: 'k-i-file-txt',
  default: 'k-i-file',
};

const UploadFileListItem = (props: UploadListItemProps) => (
  <ul className="k-reset w-full h-full overflow-y-auto">
    {props.files.map((file) => {
      const fileExtension = file.extension?.toLowerCase().replace('.', '') || 'default';
      const iconClass = fileTypeIcons[fileExtension] || fileTypeIcons.default;

      return (
        <li key={file.uid} data-uid={file.uid} tabIndex={-1}>
          <div className="k-file-single">
            <div className="k-progressbar">
              <span className="k-progress" />
            </div>
            <span className="k-file-group-wrapper">
              <span className={`k-file-group k-icon ${iconClass}`} />
              <span className="k-file-state" />
            </span>
            <span className="k-file-name-size-wrapper">
              <span className="k-file-name" title={file.name}>
                {file.name}
              </span>
              <span className="k-file-size">{(Number(file.size) / 1024).toFixed(2)} KB</span>
            </span>
            <strong className="k-upload-status mr-2">
              <button
                onClick={() => props.onRemove(file.uid)}
                type="button"
                className="k-button k-button-icon k-flat border-transparent focus:ring focus:ring-black"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onRemove(file.uid);
                  }
                }}
              >
                <span
                  aria-label="Remove"
                  title="Remove"
                  className="k-icon k-delete k-i-x focus:border focus:border-black"
                />
              </button>
            </strong>
          </div>
        </li>
      );
    })}
  </ul>
);

export default UploadFileListItem;
